"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.configure = void 0;
var tslib_1 = require("tslib");
var core_1 = tslib_1.__importDefault(require("@aws-amplify/core"));
exports.configure = function (config) { return core_1.default.configure(config); };
//# sourceMappingURL=Amplify.js.map